import dynamic from 'next/dynamic';

const SGDSAvatar = dynamic(() => import('@sgds/component-avatar'), {
  ssr: false,
});

export { SGDSAvatar };
